import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom"; // Import for navigation
import axios from "axios";
import {
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Alert,
  Progress
} from "reactstrap";
import UserForm, { validateUserForm } from "../../components/forms/UserForm";

const LoginPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [forgotEmail, setForgotEmail] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [containerMode, setContainerMode] = useState("login");
  const [isLoading, setIsLoading] = useState(false);
  const [userForm, setUserForm] = useState({
    id: "",
    email: "",
    firstName: "",
    lastName: "",
    company: "",
    phone: "",
    role: "USER",
    status: "ACTIVE",
    password: "",
    confirmPassword: ""
  });
  const location = useLocation();
  const [token, setToken] = useState(null);
  const [restPassword, setRestPassword] = useState("");
  const [restPasswordConfirmation, setRestPasswordConfirmation] = useState("");

  const apiBaseUrl = window.clipship_config.ApiBaseUrl;

  const navigate = useNavigate(); // Initialize navigation hook

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const tokenValue = queryParams.get("token");
    if (tokenValue) {
      setToken(tokenValue);
      setContainerMode("reset_password");
    }
  }, [location.search, navigate]);


  // Handle Login
  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    const loginPayload = { email, password };

    try {
      setIsLoading(true);
      const response = await axios.post(`${apiBaseUrl}/login`, loginPayload);

      // Save the token to local storage
      const token = response.data.token;
      localStorage.setItem("token", token);

      setSuccess("Login successful!");

      // Redirect to the main page
      navigate('/main');
    } catch (err) {
      setIsLoading(false);
      const errorMessage = err.response?.data?.error || "An error occurred during login.";
      setError(errorMessage);
    }
  };

  // Handle Forgot Password
  const handleForgotPassword = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    setIsLoading(true);

    const forgotPayload = { email: forgotEmail };

    try {
      await axios.post(`${apiBaseUrl}/user/forgotpassword`, forgotPayload);
      setIsLoading(false);
      setSuccess("Check your email for a link to reset your password.");
      setContainerMode("login");
    } catch (err) {
      setIsLoading(false);
      const errorMessage =
        err.response?.data?.message?.error  || "An error occurred while sending the reset email.";
      setError(errorMessage);
    }
  };


  // Handle user form changes
  const handleUserFormChange = (e) => {
    const { name, value } = e.target;
    setUserForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Handle account creation
  const handleCreateAccount = async (e) => {
    e.preventDefault();
    const errors = validateUserForm(userForm, false);
    if(!!errors) {
      setError(errors);
    } else {
      setError("");
      setSuccess("");
      setIsLoading(true);

      try {
        await axios.post(`${apiBaseUrl}/userpublic`, userForm);
        setSuccess("Account created successfully! You can now log in.");
        setContainerMode("login");
      } catch (err) {
        setError(err.response?.data?.error || "An error occurred while creating the account.  Please try again and if the issue persists contact us.");
      } finally {
        setIsLoading(false);
      }
    }
  };

  const handleResetPassword = async (e) => {
    e.preventDefault()
    if(restPassword !== restPasswordConfirmation) {
      setError("The passwords entered do not match.");
      return true;
    } else {

      setError("");
      setSuccess("");
      setIsLoading(true);

      try {
        await axios.post(`${apiBaseUrl}/user/resetpassword`, {
          "password": restPassword,
          "reset_token": token
        });
        setSuccess("Your password has been reset! You can now log in.");
        setContainerMode("login");

      } catch (err) {
        setError(err.response?.data?.error || "An error occurred while resetting the password.  Please try again and if the issue persists contact us.");
      } finally {
        setIsLoading(false);
      }
    }
  };

  let title = "Digital Data Request Login";
  if(containerMode === "forgot_password") {
    title = "Forgot Password";
  } else if(containerMode === "create_account") {
    title = "Create Account";
  } else if(containerMode === "reset_password") {
    title = "Reset Password";
  }

  const openHelp = () => {
    window.open(window.clipship_config.HelpLink, '_blank', 'noopener,noreferrer');
  }


  return (
    <div style={{background: 'linear-gradient(#7ac144CC, #149cd8CC)'}}>
      <Container className="d-flex justify-content-center align-items-center min-vh-100">
        <Row className="w-100" style={{ maxWidth: "400px" }}>
          <Col>
            <div className="p-4 shadow rounded bg-white">
            <img style={{height:80, marginLeft: 'auto', marginRight: 'auto', display: 'block'}} src="https://provopw.org/clipandship/provo_logo_color.png" />
            <h3 className="text-center mb-4" style={{marginTop:25, color: '#149cd8'}}>
                {title}
              </h3>
              {error && <Alert color="danger">{error}</Alert>}
              {success && <Alert color="success">{success}</Alert>}
              
              {containerMode == "login" &&
                <Form onSubmit={handleLogin}>
                  <FormGroup>
                    <Label for="email">Email</Label>
                    <Input
                      id="email"
                      name="email"
                      disabled={isLoading}
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label for="password">Password</Label>
                    <Input
                      id="password"
                      name="password"
                      disabled={isLoading}
                      type="password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                    />
                  </FormGroup>
                  {isLoading && <Progress animated value="100" />}
                  {!isLoading && <Button type="submit" className="rounded-pill" color="primary" block>
                    Login
                  </Button>}
                  <Row style={{marginTop: 15, textAlign: 'center'}}>
                    <Col md="12">
                      <Button
                          color="link" className="rounded-pill" style={{fontSize:15}}
                          onClick={() => setContainerMode("create_account")}
                        >
                        Create Account
                      </Button>
                    </Col>
                  <Row style={{marginTop: 5, textAlign: 'center'}}>
                    <Col md="12">
                      <Button
                        color="link" className="rounded-pill" style={{fontSize:15}}
                        onClick={() => setContainerMode("forgot_password")}
                      >
                      Forgot Password?
                      </Button>
                    </Col>
                  </Row>
                  </Row>
                  <Row style={{marginTop: 5, textAlign: 'center'}}>
                    <Col md="12">
                      <Button
                        color="link" className="rounded-pill" style={{fontSize:15}}
                        onClick={() => openHelp()}
                      >
                        Help
                      </Button>
                    </Col>
                  </Row>
                </Form>
              }
              {containerMode == "create_account" &&
                <Form onSubmit={handleCreateAccount}>
                  <UserForm userForm={userForm} onChange={handleUserFormChange} showManagementFields={false} />
                  {isLoading && <Progress animated value="100" />}
                  {!isLoading && <Button type="submit" className="rounded-pill" color="primary" block>
                    Create Account
                  </Button>}
                  <Button
                    color="link"
                    className="rounded-pill"
                    className="mt-3 w-100 text-center"
                    onClick={() => setContainerMode("login")}
                  >
                    Back to Login
                  </Button>
                </Form>
              }
              {containerMode == "forgot_password" &&
                <Form onSubmit={handleForgotPassword}>
                  <FormGroup>
                    <Label for="forgotEmail">Email</Label>
                    <Input
                      id="forgotEmail"
                      name="email"
                      type="email"
                      value={forgotEmail}
                      onChange={(e) => setForgotEmail(e.target.value)}
                      required
                    />
                  </FormGroup>
                  {isLoading && <Progress animated value="100" />}
                  {!isLoading && <Button type="submit" className="rounded-pill" color="primary" block>
                    Send Reset Link
                  </Button>}
                  <Button
                    color="link"
                    className="mt-3 w-100 text-center rounded-pill"
                    onClick={() => setContainerMode("login")}
                  >
                    Back to Login
                  </Button>
                </Form>
              }
              {containerMode == "reset_password" &&
                <Form onSubmit={handleResetPassword}>
                  <FormGroup>
                    <Label for="reset-password">New Password</Label>
                    <Input
                      id="reset-password"
                      name="reset-password"
                      type="password"
                      disabled={isLoading}
                      value={restPassword}
                      onChange={(e) => setRestPassword(e.target.value)}
                      required
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label for="reset-password-confirm">Confirm New Password</Label>
                    <Input
                      id="reset-password-confirm"
                      name="reset-password-confirm"
                      type="password"
                      disabled={isLoading}
                      value={restPasswordConfirmation}
                      onChange={(e) => setRestPasswordConfirmation(e.target.value)}
                      required
                    />
                  </FormGroup>
                  {isLoading && <Progress animated value="100" />}
                  {!isLoading && <Button type="submit" color="primary" block>
                    Reset Password
                  </Button>}
                  <Button
                    color="link"
                    className="mt-3 w-100 text-center rounded-pill"
                    onClick={() => setContainerMode("login")}
                  >
                    Back to Login
                  </Button>
                </Form>
              }
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default LoginPage;
